import React, { useContext, useState } from 'react';
import MainAppContext from '../../../../../../MainAppContext';

import { Col, Row } from 'react-bootstrap';
import { IconButton } from '@fluentui/react';
import ChangeComponentType from '../../_ComponentTypes/Dataserie/ChangeComponentType';
import SidePanelAddDataserieVariableValue from './SidePanelAddDataserieVariableValue';
import SidePanelEditDataserieVariableValue from './SidePanelEditDataserieVariableValue';
import SidePanelDeleteDataserieVariableValue from './SidePanelDeleteDataserieVariableValue';

import { getBoardVariableDataSerieValues } from '../../../../../../services/sKPI/dataserie.service';
import { updateBoardCompoenet } from '../../../../../../services/sKPI/board.service';
import { enum__ComponentType, __enum_ChartDataserieInputType } from '../../../../../../common/Dictionaries';
import moment from 'moment';
import PropTypes from 'prop-types';
import "./style.css"
import ListSimpleGrouped from '../../_ComponentTypes/Dataserie/ListSimple/ListSimpleGrouped';
import { action_setBoardDataseries, action_updateComponentInfoDataCompare, action_updateBoardFullStructure, action_updateComponentInfoData, action_updateComponentInfoDataChartCompare, action_updateChartSelectedDatapoint, action_setEvents } from '../../../../../../reducers/actions/KPI/actions';
import { useDispatch, useSelector } from 'react-redux';
import SidePanelViewDataserieAditionalInfo from './SidePanelViewDataserieAditionalInfo';

function BoardListGrouped(props) {
    const contextSite = useContext(MainAppContext);

    const { 
        inputParam_UserPropsKpi = null,
        inputParam_BoardId = null,
        inputParam_ElementId = null,
        inputParam_ColClass = null,
        inputParam_DataserieList = null,
        inputParam_ContainerComponent = null,
        inputParam_HidePanels= false,
        setBoardVariableDataserieValues = null
    } = props;

    const fieldCount = contextSite.kpiModule.boardDataserieDisplayFields.value.map(({ field }) => field).length

    return (
        <div className='container-grouped-dataseries'>
        {
            inputParam_DataserieList.map((dataserie, index) => (
                <Row key={index}  data-dataserie-id={dataserie.dataserieId} style={{width: "100%"}}>
                    <Col className={inputParam_ColClass === null ? 'pe-0 w-100' : 'px-0 w-100'}>
                        <ListSimpleGrouped
                            inputParam_UserPropsKpi={inputParam_UserPropsKpi}
                            inputParam_BoardId={inputParam_BoardId}
                            inputParam_ElementId={inputParam_ElementId}
                            inputParam_ElementList={null}
                            inputParam_Index={index}
                            inputParam_HidePanels={inputParam_HidePanels}
                            inputParam_Dataserie={dataserie}
                            setBoardVariableDataserieValues={setBoardVariableDataserieValues}
                            inputParam_DataserieList={inputParam_DataserieList}
                            inputParam_ContainerComponent={inputParam_ContainerComponent}
                            inputParam_ItemFields={contextSite.kpiModule.boardDataserieDisplayFields.value.map(({ field }) => field)}
                            inputParam_FieldCount={fieldCount}
                        />
                    </Col>
                </Row>
            ))
        }
        </div>
    );
}

BoardListGrouped.propTypes = {
    inputParam_BoardId: PropTypes.number.isRequired,
    inputParam_SetterComponentList: PropTypes.func,
    inputParam_Components: PropTypes.array.isRequired,
};

export default BoardListGrouped;